import styles from './IconDefault.module.scss';

export function IconDefault() {
	return (
		<svg
			width="40"
			height="40"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			className={styles.mediumIllustration}
		>
			<path
				d="M9.781 21.984c0-1.537 1.278-2.783 2.855-2.783h5.71c1.577 0 2.855 1.246 2.855 2.783v8.347c0 1.537-1.278 2.783-2.855 2.783h-5.71c-1.577 0-2.855-1.246-2.855-2.783v-8.347Z"
				fill="var(--coral-color-illustration-color-03, hsla(0,100%,74%,1))"
			/>
			<path
				d="M19.237 29.88a3.12 3.12 0 0 1-2.75 1.616h-6.22c-1.717 0-3.109-1.357-3.109-3.03v-9.093c0-1.673 1.392-3.03 3.11-3.03h6.218c1.718 0 3.11 1.357 3.11 3.03v7.274"
				stroke="var(--coral-color-illustration-color-02, hsla(215,69%,27%,1))"
				strokeWidth="2"
				strokeLinecap="round"
			/>
			<path
				d="M24.813 19.46c0-.828.673-1.5 1.504-1.5h6.018c.831 0 1.505.672 1.505 1.5 0 .83-.674 1.5-1.505 1.5h-6.018a1.502 1.502 0 0 1-1.505-1.5ZM24.813 25.52c0-.829.673-1.5 1.504-1.5h6.018c.831 0 1.505.671 1.505 1.5 0 .828-.674 1.5-1.505 1.5h-6.018a1.502 1.502 0 0 1-1.505-1.5ZM24.813 31.582c0-.828.673-1.5 1.504-1.5h3.01c.83 0 1.504.672 1.504 1.5s-.674 1.5-1.505 1.5h-3.009a1.502 1.502 0 0 1-1.505-1.5Z"
				fill="var(--coral-color-illustration-color-03, hsla(0,100%,74%,1))"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M2.143 14.824v-4.55c0-3.426 2.758-6.204 6.16-6.204h24.64c3.402 0 6.16 2.778 6.16 6.204v4.55H2.143Zm7.512-7.183a1.5 1.5 0 1 0-3 0 1.5 1.5 0 0 0 3 0Zm4.514 0a1.5 1.5 0 1 0-3 0 1.5 1.5 0 0 0 3 0Zm3.014-1.5a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3Z"
				fill="var(--coral-color-illustration-color-03, hsla(0,100%,74%,1))"
			/>
			<path
				d="M2.143 9.07c0-3.348 2.694-6.062 6.018-6.062h24.073c3.323 0 6.018 2.714 6.018 6.061v21.215c0 1.652-.656 3.15-1.72 4.243m-10.43 1.818H8.16c-3.324 0-6.018-2.714-6.018-6.061V14.826"
				stroke="var(--coral-color-illustration-color-02, hsla(215,69%,27%,1))"
				strokeWidth="2"
				strokeLinecap="round"
			/>
			<circle
				cx="24.385"
				cy="18.164"
				r="1"
				fill="var(--coral-color-illustration-color-02, hsla(215,69%,27%,1))"
			/>
			<circle
				cx="27.82"
				cy="18.164"
				r="1"
				fill="var(--coral-color-illustration-color-02, hsla(215,69%,27%,1))"
			/>
			<circle
				cx="29.83"
				cy="36.346"
				r="1"
				fill="var(--coral-color-illustration-color-02, hsla(215,69%,27%,1))"
			/>
			<circle
				cx="33.496"
				cy="35.945"
				r="1"
				fill="var(--coral-color-illustration-color-02, hsla(215,69%,27%,1))"
			/>
			<path
				d="M30.695 18.164h2.643m-1.805 6.162H24.01m0 6.163h4.212"
				stroke="var(--coral-color-illustration-color-02, hsla(215,69%,27%,1))"
				strokeWidth="2"
				strokeLinecap="round"
			/>
		</svg>
	);
}
